/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';

import './PercentBar.css';

const barPadding = 12;
const barPaddingSmall = 4;


export function colorForRating(percent) {
  let colors = [
    [90, '#8f64ff'],
    [80, '#549fef'],
    [70, '#64e291'],
    [60, '#e6e56c'],
    [50, '#fec771'],
    [0, '#eb7070'],
  ];
  for (let j = 0; j < colors.length; j++) {
    if (percent >= colors[j][0]) {
      return colors[j][1];
    }
  }
}


export function borderColorForRating(percent) {
  let colors = [
    [90, '#9b68c0'],
    [0, '#ccc'],
  ];
  for (let j = 0; j < colors.length; j++) {
    if (percent >= colors[j][0]) {
      return colors[j][1];
    }
  }
}


function percentToWidth(width, hoverPercent, props) {
  if (hoverPercent < 1) {
    hoverPercent = 1;
  }
  if (hoverPercent > 100) {
    hoverPercent = 100;
  }

  let percent = hoverPercent / 100;

  let useBarPadding = barPadding;
  if (props.size == 'small') {
    useBarPadding = barPaddingSmall;
  }
  return (percent * width) - useBarPadding;
}


class PercentBar extends Component {
  state = { showLevels: false };

  constructor(props) {
    super(props);
    if (props.percent) {
      this.state.percent = props.percent;
    }
  }

  componentDidMount() {
    if (this.state.percent) {
      let fn = () => this.setPercent(this.state.percent, true);
      fn();
      setTimeout(fn, 300);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.percent != this.props.percent) {
      this.setPercent(this.props.percent, true);
    }
  }

  ratingMove(e) {
    if (!this.state.dragging) return;
    this.updateHoversFrom(e.clientX);
  }

  updateHoversFrom(clientX) {
    let width = this.refs.bar.getBoundingClientRect().width;
    let left = this.refs.bar.getBoundingClientRect().left
    let percent = (clientX - left) / width;

    // console.log('WIDTH', width);
    // console.log('percent', percent);

    let hoverPercent = Math.round(100 * percent);
    let hoverWidth = percentToWidth(width, hoverPercent, this.props);

    this.setState({
      hoverPercent,
      hoverWidth,
    });
  }

  ratingClick(e) {
    if (this.props.noEdit) return;

    let percent = this.state.hoverPercent;

    console.log('debug w render RATING CLICK', this.state.hoverWidth);

    this.setState({
      percent,
      width: this.state.hoverWidth,
    });

    if (this.props.onChange) {
      this.props.onChange(percent);
    }
  }

  startTouch(e) {
    if (this.props.noEdit) return;
    this.updateHoversFrom(e.touches[0].clientX);
    this.setState({ showLevels: true });
    e.preventDefault();
    this.touching = true;
  }

  moveTouch(e) {
    if (this.props.noEdit) return;
    this.updateHoversFrom(e.touches[0].clientX);
  }

  endTouch(e) {
    if (this.props.noEdit) return;
    this.touching = false;
    this.endDrag(e);
  }

  startDrag(e) {
    if (this.props.noEdit) return;
    this.setState({ showLevels: true });
    if (this.touching) return;

    e.preventDefault();
    console.log('start drag', e);

    this.setState({ dragging: true });
    this.updateHoversFrom(e.clientX);
    let fnMove = (e) => {
      this.ratingMove(e);
    };
    let fnUp = (e) => {
      this.endDrag(e);
      window.removeEventListener('mouseup', fnUp, false);
      window.removeEventListener('mousemove', fnMove, false);
    };
    window.addEventListener('mouseup', fnUp, false);
    window.addEventListener('mousemove', fnMove, false);
  }

  endDrag(e) {
    e.preventDefault();
    this.updateHoversFrom(e.clientX);
    this.ratingClick(e);
    this.setState({ hoverPercent: 0, hoverWidth: 0, dragging: false });
  }

  setPercent(percent, noOnChange) {
    percent = parseInt(percent);
    if (percent > 100) {
      percent = 100;
    }
    if (percent <= 0) {
      percent = 1;
    }
    if (isNaN(percent)) {
      percent = 0;
    }

    let width = this.refs.bar.getBoundingClientRect().width;
    let left = this.refs.bar.getBoundingClientRect().left

    let widthPercent = percent;
    if (!percent) {
      widthPercent = 0;
    }

    // console.log('SET PERCENT', percent, widthPercent, width);

    // let setWidth = ((widthPercent / 100) * width) - barPadding;
    // if (setWidth < 0) {
    //   setWidth = 0;
    // }

    let setWidth = percentToWidth(width, widthPercent, this.props);

    this.setState({
      percent: percent,
      width: setWidth,
    });

    console.log('debug percent', percent, this.props.onChange, noOnChange);
    if (!noOnChange && this.props.onChange) {
      this.props.onChange(percent);
    }
  }

  render() {
    let percent = this.state.percent || 0;
    let hoverWidth = Math.round(this.state.hoverWidth || 0);
    let width = Math.round(this.state.width || 0);

    console.log('debug w render width hover', hoverWidth, width);

    let levels = [
      [100, 'Perfection', 'A world class room that will blow your mind. Book a flight now.'],
      [90, 'Amazing!', 'Worth travelling to the city just for this room.'],
      [80, 'Great!', "If you're in the city, definitely do this room."],
      [70, 'Good', "You'll enjoy it, even if it's not very unique."],
      [60, 'So-so', "There may be some redeeming qualities."],
      [50, 'Meh', "Big flaws and mediocre overall."],
      [40, 'Bad', "Avoid this room, you won't have fun."],
      [0,  'Terrible', "Broken puzzles, don't waste your time/money."],
    ];

    for (let i = 0; i < levels.length; i++) {
      let color = colorForRating(levels[i][0]);
      let borderColor = borderColorForRating(levels[i][0]);
      levels[i].push(color);
      levels[i].push(borderColor);
    }

    let levelMessage = '';
    let level = null;
    let cmpPercent = this.state.hoverPercent ? Math.round(this.state.hoverPercent) : percent;
    for (let l of levels) {
      if (!level && cmpPercent && cmpPercent >= l[0]) {
        level = l;
      }
    }

    let color = '#333';
    let borderColor = '#333';
    if (level) {
      color = level[3];
      borderColor = level[4];
    }

    let showClickToRate = !cmpPercent && !this.touching;

    return (
      <div className={cx('PercentBar', this.props.size)}>
         <div
           className="rating-number-wrapper"
           >
           {showClickToRate && <div className="click-to-rate desktop">
            <div><b>Click here to rate</b></div>
            <div>Drag the bar to set your rating for this room</div>
            </div>}
           {showClickToRate && <div className="click-to-rate phone">
            <div><b>Tap and slide to rate</b></div>
            </div>}
           <div
             className="rating-percent"
             onMouseDown={(e) => this.startDrag(e)}
             onTouchStart={(e) => this.startTouch(e)}
             onTouchMove={(e) => this.moveTouch(e)}
             onTouchEnd={(e) => this.endTouch(e)}
             ></div>
           <div className="rating-percent-number">
             {cmpPercent != 0 && cmpPercent}
           </div>
           <div
             className="rating-bar"
             ref="bar"
             >
             <div className="hover-rating" style={{ width: hoverWidth + 'px', background: color, borderColor }}></div>
             {!hoverWidth && <div className="rating" style={{ width: width + 'px', background: color, borderColor }}>
             </div>}
           </div>
           <div className="level-wrapper">
             <div className="level">{level && level[1]}</div>
             <div className="level-small">{level && level[2]}</div>
           </div>
        </div>

      </div>
    );
  }
}


export default PercentBar;



/** WEBPACK FOOTER **
 ** ./src/components/partials/PercentBar.js
 **/